var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapeSpace1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1655,
    height: 50,
    viewBox: "0 0 1655 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1655V50H40L0 0Z",
    fill: "#0132B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSpace1);
export default __webpack_public_path__ + "static/media/shape_space_1.4e29ec4b35c80060ab4ce65c201d5a10.svg";
export { ForwardRef as ReactComponent };